import { render, staticRenderFns } from "./cmpinformacoescliente.vue?vue&type=template&id=e6cd238c&"
import script from "./cmpinformacoescliente.vue?vue&type=script&lang=js&"
export * from "./cmpinformacoescliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports